import { isNotNullOrUndefined } from '@deltasierra/type-utilities';
import { NoParams } from './app-routes/no-params';

type RouteParamsMap = Record<string, string | undefined>;

export type RouteDefinitionMap = Record<string, NoParams | RouteParamsMap>;

// Conditional tuple type that includes params only if they exist
export type BuildParamsTuple<
    RouteMap extends RouteDefinitionMap,
    Route extends keyof RouteMap,
> = RouteMap[Route] extends NoParams ? [] : [RouteMap[Route]];

export class RouteBuilder<RouteMap extends RouteDefinitionMap> {
    public build<Route extends keyof RouteMap>(
        subRoute: Route,
        ...[params]: BuildParamsTuple<RouteMap, Route>
    ): string {
        let path = subRoute.toString();

        // If params are defined, process them
        if (isNotNullOrUndefined(params)) {
            const pathParams: Record<string, string> = {};
            const queryParams: Record<string, string> = {};

            // Determine which params are path params vs query params
            for (const [key, value] of Object.entries(params)) {
                // Only append non-null query params
                if (isNotNullOrUndefined(value)) {
                    // Check if this parameter is used in the path (contains :paramName)
                    if (path.includes(`:${key}`)) {
                        pathParams[key] = value;
                    } else {
                        queryParams[key] = value;
                    }
                }
            }

            // Replace path parameters
            for (const [key, value] of Object.entries(pathParams)) {
                path = path.replace(`:${key}`, value);
            }

            // Add query parameters
            if (Object.keys(queryParams).length > 0) {
                const paramsBuilder = new URLSearchParams(queryParams);
                path += `?${paramsBuilder.toString()}`;
            }
        }

        return path;
    }
}
